export enum CheckoutSearchKeys {
  TYPE = "types",
  SEARCH = "search",
}
